
import { apiFetch } from './index.js';

/**
 * Obtener todos los pagos de salida de equipo
 */
export const obtenerPagosSalidaEquipo = async () => {
    try {
        const response = await apiFetch('/PagoSalidaEquipo');
        return { success: true, data: response };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

/**
 * Crear un nuevo pago de salida de equipo
 * @param {Object} data - Datos del pago (CreatePagoSalidaEquipoDTO)
 */
export const crearPagoSalidaEquipo = async (data) => {
    try {
        const response = await apiFetch('/PagoSalidaEquipo', {
            method: 'POST',
            body: data
        });
        return { success: true, data: response };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

/**
 * Obtener pagos por detalle de salida
 * @param {number} idSalidaDetalle 
 */
export const obtenerPagosPorSalidaDetalle = async (idSalidaDetalle) => {
    try {
        const response = await apiFetch(`/PagoSalidaEquipo/salida-detalle/${idSalidaDetalle}`);
        return { success: true, data: response };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

/**
 * Obtener pagos realizados por recepción
 * @param {number} idRecepcionEquipo 
 */
export const obtenerPagosPorRecepcion = async (idRecepcionEquipo) => {
    try {
        const response = await apiFetch(`/PagoSalidaEquipo/porRecepcion/${idRecepcionEquipo}`);
        return { success: true, data: response };
    } catch (error) {
        return { success: false, error: error.message };
    }
};
